import React, { Component } from "react";

function ApprovedReq() {
  return <div>ApprovedReq</div>;
}

export default ApprovedReq;
